@use '@/sass/variables';

.Cell {
  padding: variables.$font-size-6;
  border-right: variables.$border-width-apitable solid variables.$moon-gray;
  border-bottom: variables.$border-width-apitable solid variables.$moon-gray;
  display: flex;
  align-items: center;
  min-height: 55px;
  min-width: 0;
  font-size: 0.875rem;
  color: variables.$near-black;

  &:last-child {
    border-right: none;
  }
}

.HeaderCell {
  composes: Cell;
  background: variables.$light-gray;
  font-weight: 500;
  font-size: 0.925rem;
  color: variables.$near-black;
  user-select: none;
  position: sticky;
  top: 0;
  z-index: 10;
}

.LeafCell {
  composes: Cell;
  background: variables.$near-white;
  min-height: calc(55px * 0.75);
}

.SampleNamesTable {
  display: grid;
  border-top: variables.$border-width-apitable solid variables.$moon-gray;
  background: variables.$white;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: auto;
  scroll-behavior: smooth;

  .Header {
    display: contents;
  }

  .RootRow {
    display: contents;
  }

  .NestedRow {
    display: contents;
  }

  .LeafRow {
    display: contents;
  }
}

.TreeCellContent {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
  flex: 1;
}

.TreeCellRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.CountBadge {
  font-size: 0.75rem;
  color: variables.$mid-gray;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: auto;
}

.DimensionLabel {
  font-size: 0.75rem;
  color: variables.$mid-gray;
  line-height: 1;
}

.TreeCell {
  composes: Cell;
  cursor: default;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding-left: calc(#{variables.$font-size-6} + var(--depth, 0) * 1.5rem);

  svg {
    transition: transform 0.2s ease;
    transform-origin: center;
    flex-shrink: 0;
  }
}

.TreeCell.Clickable {
  cursor: pointer;

  &:hover {
    color: variables.$dark-blue;
  }
}

.Open {
  > svg {
    transform: rotate(90deg);
  }
}

.TreeCellSpinner {
  flex-shrink: 0;
}

.Closed {
  > svg {
    transform: rotate(0deg);
  }
}

.FlatTableContainer {
  :global(.ui-card) {
    border: none;
    box-shadow: none;
    border-radius: 0;

    > div:first-child {
      padding-top: 0;
    }
  }
}

.GroupChipList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.125rem;
}

.StudyGroupsCell {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 0.25rem;
}

.GroupInfoButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center !important;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  height: auto;
  color: variables.$mid-gray;
  flex-shrink: 0;
  margin-left: auto;
  box-shadow: none;

  &:hover,
  &:focus,
  &:active {
    color: variables.$mid-gray;
    background: none;
    border: none;
    box-shadow: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: none;
    border-radius: 0;
  }
}

.GroupChipItem {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: variables.$border-radius-2;
  width: 1.75rem;
  height: 1.75rem;
  flex-shrink: 0;
  background-color: variables.$mid-gray;
}

.GroupChipCount {
  font-size: 0.75rem;
  font-weight: 600;
  color: variables.$white;
  line-height: 1;
}

.GroupChipOverflowItem {
  composes: GroupChipItem;
  background-color: transparent;
  border: 1px solid variables.$mid-gray;

  .GroupChipCount {
    color: variables.$mid-gray;
  }
}

.CheckboxCell {
  composes: Cell;
  justify-content: center;
  padding: 0;
  cursor: pointer;

  input[type='checkbox'] {
    cursor: pointer;
  }
}

.HeaderCheckboxCell {
  composes: HeaderCell;
  justify-content: center;
  padding: 0;
  cursor: pointer;

  input[type='checkbox'] {
    cursor: pointer;
  }
}

.LeafCheckboxCell {
  composes: LeafCell;
  justify-content: center;
  padding: 0;
  cursor: pointer;

  input[type='checkbox'] {
    cursor: pointer;
  }
}

.InlineCell {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  padding: variables.$font-size-6;
  min-height: 55px;
  font-size: 0.875rem;
  border-bottom: variables.$border-width-apitable solid variables.$moon-gray;
  color: variables.$mid-gray;
}
